import { useEffect } from "react";
import Title from "common/Typography/Title";
import IconWithFallback from "Global/IconWithFallback";
import ConnectedAmountPercentInputs from "common/Inputs/ConnectedAmountPercentInputs";
import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import { toFixed } from "@shared/utils/numbers";
import { ICON_TYPES } from "@shared/common/constants";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.js";
import { LanguageNameSpaces } from "@shared/types/index.js";

const AmountInput = ({
  coin,
  setError,
  isEntry,
  selectedAmount,
  setSelectedAmount,
  amountPrecision,
  error,
  conversionMinCost,
  availableCost,
}) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const defaultPercent = isEntry ? 20 : 100;

  useEffect(() => {
    if (availableCost) {
      const defaultCost =
        (defaultPercent / 100) * toFixed(availableCost, amountPrecision);
      setSelectedAmount(toFixed(defaultCost, amountPrecision));
    }
  }, [availableCost]);

  return (
    <>
      <Title type="secondary" level={4} style={{ textAlign: "center" }}>
        {t("create_order.amount")}
      </Title>
      <Flex $alignItems="baseline" $justifyContent="center">
        <ConnectedAmountPercentInputs
          amountPrecision={amountPrecision}
          percentPrecision={2}
          availableAmount={availableCost}
          amount={selectedAmount}
          onAmountChange={setSelectedAmount}
          maxPercent={100}
          defaultPercent={isEntry ? 20 : 100}
          icon={
            <IconWithFallback
              coinOrExchangeName={coin}
              iconType={ICON_TYPES.COIN}
              iconStyle={{
                marginRight: 6,
              }}
              iconSize={"l"}
            />
          }
        />
      </Flex>
      <ValidationMessage
        availableCost={availableCost}
        amountPrecision={amountPrecision}
        currentAmount={selectedAmount}
        setError={setError}
        error={error}
        conversionMinCost={conversionMinCost}
      />
    </>
  );
};

export default AmountInput;

const ValidationMessage = ({
  availableCost,
  amountPrecision,
  currentAmount,
  setError,
  error,
  conversionMinCost,
}) => {
  const maxAmountDisplay = toFixed(availableCost, amountPrecision);

  useEffect(() => {
    if (
      !currentAmount ||
      currentAmount < conversionMinCost ||
      currentAmount > maxAmountDisplay
    ) {
      setError(true);
    } else {
      setError(false);
    }
  }, [currentAmount, conversionMinCost, maxAmountDisplay]);

  return (
    <Text
      as={"div"}
      type={error ? "danger" : "primary"}
      style={{ textAlign: "center" }}
    >
      Amount should be between {conversionMinCost} and {maxAmountDisplay}
    </Text>
  );
};
